import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TreatmentOptionState } from "./treatment-option.state";

const selectTreatmentOptionfeatureState = createFeatureSelector<TreatmentOptionState>('treatmentOptionStore')

export const selectPracticeTreatmentOptions = createSelector(
    selectTreatmentOptionfeatureState,
    state => state.practiceTreatmentOptions
)

export const selectTreatmentOptionStateEvent = createSelector(
    selectTreatmentOptionfeatureState,
    state => state.treatmentOptionStateEvent
)

export const selectTreatmentOption = createSelector(
    selectTreatmentOptionfeatureState,
    state => state.selectedTreatmentOption
) 